import axios from "axios";
import { config } from "../config/config";
import Cookies from "js-cookie";
import { Navigate } from "react-router-dom";
import { refreshAccessToken } from "../services/admin/auth.service";

axios.defaults.withCredentials = true;

const api = axios.create({
  baseURL: config.BASE_API,
  withCredentials: true,
    headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    // console.log("🚀 ~ token:", token)
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);


api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const status = error.response?.status;

    // Detect login request
    const isLoginRequest =
      originalRequest?.url?.endsWith("/api/v1/auth/login") ||
      originalRequest?.url?.includes("/auth/login");

    // ❌ Skip refresh & redirect for login calls
    if (isLoginRequest && status === 401) {
      return Promise.reject(error); // Let UI handle wrong credentials
    }

    // 🔄 Token expired or invalid (non-login requests)
    if ((status === 498 || status === 401) && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const newAccessToken = await refreshAccessToken();
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return api(originalRequest); // Retry
      } catch (refreshError) {
        localStorage.removeItem("access_token");
        window.location.href = "/login"; // Only redirect here
        return Promise.reject(refreshError);
      }
    }

    // Other errors
    if (status === 400) {
      console.log("ERROR:", error.message);
    } else if (status === 403) {
      console.log("ERROR:", error.message);
    } else {
      console.log("ERROR:", error.message);
    }

    return Promise.reject(error);
  }
);


export { api };
